(function () {
  // Safety check: config must exist
  // Safety check: config must exist
  if (
    !window.PINCODE_EXPERIMENT_CONFIG ||
    !window.PINCODE_EXPERIMENT_CONFIG.enabled
  ) {
    // If config doesn't exist, disable everything
    deleteCookie("pincode_ab_group");
    deleteCookie("random-value");
    deleteCookie("pincodePopupShown");
    deleteCookie("isExpress");
    deleteCookie("user_pincode");
    deleteCookie("addToCartPopShow");
    deleteCookie("sapCode");
    deleteCookie("pincode_start_fired");
    return;
  }

  var globalExpressEnabled = window.PINCODE_EXPERIMENT_CONFIG.enabled;
  var excludedSapCodes = (
    window.PINCODE_EXPERIMENT_CONFIG.excludedSapCodes || ""
  )
    .split(",")
    .map((code) => code.trim())
    .filter((code) => code.length > 0);
  var currentSapCode = getCookie("sapCode"); // Assuming sapCode is stored in a cookie

  // Determine if express delivery is enabled for the current SAP code
  var expressEnabledForSapCode = globalExpressEnabled; // Start with global setting

  if (currentSapCode && excludedSapCodes.includes(currentSapCode)) {
    expressEnabledForSapCode = false; // Override: disable if current SAP code is in the excluded list
  }

  if (!expressEnabledForSapCode) {
    deleteCookie("isExpress"); // Only delete isExpress
  }

  var COOKIE_NAME = "pincode_ab_group";
  var TEST_PERCENTAGE = Number(window.PINCODE_EXPERIMENT_CONFIG.testPercentage);

  function deleteCookie(name) {
    document.cookie = `${name}=; Max-Age=0; path=/;`;
  }

  // --- Cookie helpers ---
  function getCookie(name) {
    var match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    return match ? match[2] : null;
  }

  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";
  }

  // --- Group assignment ---
  // Pass expressEnabledForSapCode to assignABGroup
  function assignABGroup(isExpressFeatureEnabled) {
    var existingGroup = getCookie(COOKIE_NAME);
    if (existingGroup === "test" || existingGroup === "control") {
      return existingGroup;
    }

    // If express feature is not enabled (globally or due to excluded SAP code) → always control
    if (isExpressFeatureEnabled === false) {
      setCookie(COOKIE_NAME, "control", 30);
      return "control";
    }

    var random = Math.random(); // 0 → 1
    var group = random < TEST_PERCENTAGE ? "test" : "control";

    setCookie(COOKIE_NAME, group, 30); // 30 days persistence
    setCookie("random-value", random, 30); // 30 days persistence
    return group;
  }

  var group = assignABGroup(expressEnabledForSapCode); // Call with the new flag

  // Expose globally (read-only)
  window.PINCODE_AB_GROUP = group;

  if (group === "test" && !getCookie("pincode_start_fired")) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "pincode_start",
    });

    setCookie("pincode_start_fired", "1", 30);
  }
})();
